function Footer() {
  return (
    <>
      {/* footer section */}
      <footer className="site-footer">
        <div className="container">
          <div className="flex flex-wrap">
            <div className="footer-menu branding-section w-full md:w-1/4">
              <a href="/landing" title="Casava" aria-label="Casava">
                <svg
                  width="132"
                  height="30"
                  viewBox="0 0 132 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  svg-inline=""
                  role="presentation"
                  focusable="false"
                  tabIndex="-1"
                >
                  <path
                    d="M57.994 9.403c1.307 0 1.647 1.142 1.647 1.935 0 .836-.441 1.874-.782 2.205h3.671c.504-.602 1.145-2.078 1.145-3.25-.007-2.519-1.718-5.084-5.822-5.084-3.383 0-6.059 1.36-6.516[...]"
                    fill="#FF147D"
                  ></path>
                </svg>
              </a>
              <div className="footer-social__icons">
                <a
                  href="https://twitter.com/gocasava"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Twitter"
                >
                  <svg
                    width="21"
                    height="21"
                    viewBox="0 0 21 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    svg-inline=""
                    role="presentation"
                    focusable="false"
                    tabIndex="-1"
                  >
                    <g clipPath="url(#clip0_1050_211)">
                      <path d="M20.5 4.527a8.192 8.192 0 01-2.357.646 4.11 4.11 0 001.805-2.27 8.22 8.22 0 01-2.606.996 4.096 4.096 0 00-2.995-1.296c-2.65 0-4.596 2.472-3.998 5.038a11.649 11.649 0[...]"/>
                    </g>
                    <defs>
                      <clipPath id="clip0_1050_211">
                        <path
                          fill="#fff"
                          transform="translate(.5 .73)"
                          d="M0 0h20v20H0z"
                        ></path>
                      </clipPath>
                    </defs>
                  </svg>
                </a>
                <a
                  href="https://facebook.com/gocasava"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Facebook"
                >
                  <svg
                    width="21"
                    height="21"
                    viewBox="0 0 21 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    svg-inline=""
                    role="presentation"
                    focusable="false"
                    tabIndex="-1"
                  >
                    <g clipPath="url(#clip0_1050_213)">
                      <path d="M8 7.397H5.5v3.333H8v10h4.167v-10h3.035l.298-3.333h-3.333v-1.39c0-.795.16-1.11.929-1.11H15.5V.73h-3.173C9.33.73 8 2.05 8 4.576v2.82z"></path>
                    </g>
                    <defs>
                      <clipPath id="clip0_1050_213">
                        <path
                          transform="translate(.5 .73)"
                          d="M0 0h20v20H0z"
                        ></path>
                      </clipPath>
                    </defs>
                  </svg>
                </a>
                <a
                  href="https://instagram.com/gocasava"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Instagram"
                >
                  <svg
                    width="21"
                    height="21"
                    viewBox="0 0 21 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    svg-inline=""
                    role="presentation"
                    focusable="false"
                    tabIndex="-1"
                  >
                    <g clipPath="url(#clip0_1050_215)">
                      <path d="M14.9.73a5.495 5.495 0 015.49 5.489v8.912a5.495 5.495 0 01-5.49 5.488H5.99A5.495 5.495 0 01.5 15.131V6.219A5.495 5.495 0 015.989.73H14.9zm3.725 14.4V6.22a3.729 3.72[...]"/>
                    </g>
                    <defs>
                      <clipPath id="clip0_1050_215">
                        <path
                          transform="translate(.5 .73)"
                          d="M0 0h20v20H0z"
                        ></path>
                      </clipPath>
                    </defs>
                  </svg>
                </a>
              </div>
              <span className="copyright-text">
                © {new Date().getFullYear()} Casava Inc. All Rights Reserved
              </span>
            </div>
            <div className="footer-menu-items flex flex-wrap justify-evenly w-full md:w-3/4">
              <div className="footer-menu w-full md:w-auto">
                <h6>Our Products</h6>
                <ul>
                  <li>
                    <a href="/health-insurance" aria-label="Health Insurance">
                      Health Insurance
                    </a>
                  </li>
                  <li>
                    <a href="/health-cash" aria-label="Health Cash">
                      Health Cash
                    </a>
                  </li>
                  <li>
                    <a href="/business-gro" aria-label="Business Gro">
                      BusinessGro
                    </a>
                  </li>
                  <li>
                    <a href="/credit-life" aria-label="Credit Life">
                      Credit Life
                    </a>
                  </li>
                </ul>
              </div>
              <div className="footer-menu w-full md:w-auto">
                <h6>Company</h6>
                <ul>
                  <li>
                    <a href="/about" aria-label="About">
                      About
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://gocasava.notion.site/gocasava/Seeders-at-Casava-47266a1e056841dfa1b87d13b538c240"
                      target="_blank"
                      rel="noreferrer"
                      aria-label="Careers"
                    >
                      Careers
                    </a>
                  </li>
                  {/* <li><a href="" aria-label="Privacy Policy">Privacy Policy</a></li> */}
                  <li>
                    <a href="/#" aria-label="Legal">
                      Legal
                    </a>
                  </li>
                </ul>
              </div>
              <div className="footer-menu w-full md:w-auto">
                <h6>Policy</h6>
                <ul>
                  <li>
                    <a href="privacy-policy" aria-label="Privacy Policy">
                      Privacy Policy
                    </a>
                  </li>
                  <li>
                    <a href="terms" aria-label="Terms and Conditions">
                      Terms and Conditions
                    </a>
                  </li>
                </ul>
              </div>
              <div className="footer-menu w-full md:w-auto">
                <h6>Contact</h6>
                <ul>
                  <li>
                    <a
                      href="mailto:hello@casava.com"
                      aria-label="hello@casava.com"
                      target="_blank"
                      rel="noreferrer"
                    >
                      hello@casava.com
                    </a>
                  </li>
                  <li>
                    <a
                      href="tel:+2342013309618"
                      aria-label="+234 201 330 9618"
                      target="_blank"
                      rel="noreferrer"
                    >
                      +234 201 330 9618
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://wa.me/2347025004444"
                      aria-label="WhatsApp +234 702 500 4444"
                      target="_blank"
                      rel="noreferrer"
                    >
                      WhatsApp: +234 702 500 4444
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://maps.app.goo.gl/RWHjcMhG9M6kb3v59"
                      aria-label="17 Olosa Street, V.I, Lagos"
                      target="_blank"
                      rel="noreferrer"
                    >
                      17 Olosa Street, V.I, Lagos
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <span className="copyright-text mt-16">
              Casava Inc. is a Delaware, USA registered LLC Corporation. Casava
              Microinsurance Limited (CML) is registered in the Federal Republic
              of Nigeria and licensed by National Insurance Commission (NAICOM)
              to provide life and general microinsurance underwriting services.
            </span>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
